module.exports = __webpack_public_path__ + "img/38.c42fab5f.jpg";